export default {
      id: "checkmark-usage",
      viewBox: "0 0 44.6 34.2",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#checkmark",
      toString: function () {
        return this.url;
      }
    }